import { MIMETYPE_JSON } from '@disy/lib/media-type';

import { ajax } from 'cadenza/api-client/api';
import type { FolderId } from 'cadenza/repository/model/folder-id.gen';
import type { FolderName } from 'cadenza/repository/model/folder-name.gen';
import type { RepositoryItemId } from 'cadenza/repository/model/repository-item-id';
import type { RepositoryName } from 'cadenza/repository/model/repository-name.gen';
import type { RepositoryTreeNodeWithoutIcon } from 'cadenza/repository/model/repository-tree-node-dto';

export function getRepositoryNavigatorTree(repositoryName: RepositoryName) {
  return ajax<RepositoryTreeNodeWithoutIcon>(`/repositories/${repositoryName}/navigator-tree`);
}

export function createNavigatorTreeFolder(
  repositoryName: RepositoryName,
  printName: string,
  parentId: FolderId | undefined,
) {
  return ajax<RepositoryTreeNodeWithoutIcon>(`/repositories/${repositoryName}/navigator-tree/folders`, {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify({ printName, parentId }),
  });
}

export function moveNavigatorTreeNode(
  { repositoryName, itemType, itemName }: RepositoryItemId,
  parentId?: FolderId,
  nextSiblingId?: RepositoryItemId,
) {
  return ajax<RepositoryTreeNodeWithoutIcon>(
    `/repositories/${repositoryName}/navigator-tree/${itemType}/${itemName}/parent`,
    {
      type: 'PUT',
      contentType: MIMETYPE_JSON,
      data: JSON.stringify({ parentId, nextSiblingId }),
    },
  );
}

export function setRepositoryTreeLeafLabels(
  { repositoryName, itemType, itemName }: RepositoryItemId,
  labels: string[],
) {
  return ajax<RepositoryTreeNodeWithoutIcon>(
    `/repositories/${repositoryName}/navigator-tree/${itemType}/${itemName}/labels`,
    {
      type: 'PUT',
      contentType: MIMETYPE_JSON,
      data: JSON.stringify(labels),
    },
  );
}

export function renameNavigatorFolder(repositoryName: RepositoryName, folderName: FolderName, newPrintName: string) {
  return ajax<RepositoryTreeNodeWithoutIcon>(
    `/repositories/${repositoryName}/navigator-tree/folders/${folderName}/name`,
    {
      type: 'PUT',
      contentType: MIMETYPE_JSON,
      data: newPrintName,
    },
  );
}

export function deleteNavigatorFolder(repositoryName: RepositoryName, folderName: FolderName) {
  return ajax<RepositoryTreeNodeWithoutIcon>(`/repositories/${repositoryName}/navigator-tree/folders/${folderName}`, {
    type: 'DELETE',
  });
}
